import React, { useContext, useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./styles.scss";
import { Sidebar, Footer, ScrollToTop } from "./components";
import { AuthContext } from "./contexts/AuthContext";
import { useStateContext } from "./contexts/ContextProvider";
import { messaging } from "./firebase";
import { onMessage } from "firebase/messaging";
import {
  Login,
  ProfilUser,
  UbahProfilUser,
  DaftarUser,
  TambahUser,
  UbahUser,
  TampilSetting,
  UbahSetting,
  TampilCustomer,
  UbahCustomer,
  TambahCustomer,
  TampilArsitek,
  UbahArsitek,
  TambahArsitek,
  TampilCabang,
  UbahCabang,
  TambahCabang,
  TampilDaftarProyek,
  TambahProyek,
  TampilProyek,
  UbahProyek,
  LapProyekSemua,
  LapProyekMenunggu,
  TampilDaftarRab,
  TambahRab,
  TampilRab,
  UbahRab,
  TampilRabPekerjaan,
  TambahRabPekerjaan,
  UbahRabPekerjaan,
  TampilRabPekerjaanChild,
  TambahRabPekerjaanChild,
  UbahRabPekerjaanChild,
  TampilDaftarKirimGambar,
  TampilKirimGambar,
  TambahKirimGambar,
  UbahKirimGambar,
  TampilDaftarRevisi,
  TampilRevisi,
  UbahRevisi,
  TambahRevisi,
  TampilDaftarPreOrder,
  TampilPreOrder,
  UbahPreOrder,
  TambahPreOrder,
  TampilDaftarProduksi,
  TampilProduksi,
  UbahProduksi,
  TambahProduksi,
} from "./pages/index";
import { FaBars } from "react-icons/fa";
import toast, { Toaster } from "react-hot-toast";

const App = () => {
  const { screenSize, setScreenSize } = useStateContext();
  const { user } = useContext(AuthContext);
  const [collapsed, setCollapsed] = useState(false);
  const [toggled, setToggled] = useState(false);

  const handleCollapsedChange = () => {
    setCollapsed(!collapsed);
  };

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  const notify = (body) => {
    toast.custom(
      (t) => (
        <div
          style={{
            background: "#333",
            color: "white",
            padding: "12px 16px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
            minWidth: "260px",
          }}
        >
          <span style={{ whiteSpace: "pre-line" }}>{body}</span>
          <button
            onClick={() => toast.dismiss(t.id)}
            style={{
              background: "transparent",
              border: "none",
              color: "#fff",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>
      ),
      {
        duration: Infinity, // 👈 stick forever
        position: "top-right",
      }
    );
  };

  const USERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user) {
      return children;
    }

    return <Navigate to="/login" />;
  };

  const PROFILUSERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.profilUser) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const DAFTARUSERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.daftarUser) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const SETTINGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.setting) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const CUSTOMERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.customer) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const ARSITEKRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.arsitek) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const CABANGRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.cabang) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const PROYEKRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.proyek) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPPROYEKSEMUARoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.lapProyekSemua) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const LAPPROYEKMENUNGGURoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.lapProyekMenunggu) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const RABRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.rab) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const KIRIMGAMBARRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.kirimGambar) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const REVISIRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.revisi) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const PREORDERRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.preOrder) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  const PRODUKSIRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (user.akses.produksi) {
      return children;
    }

    return <Navigate to="/unauthorized" />;
  };

  useEffect(() => {
    onMessage(messaging, (payload) => {
      // console.log(payload);
      notify(payload.notification.body);
    });

    // const handleResize = () => setScreenSize(window.innerWidth);
    // window.addEventListener("resize", handleResize);
    // handleResize();
    // return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Toaster />
      <div className={`app ${toggled ? "toggled" : ""}`}>
        {user && (
          <Sidebar
            collapsed={collapsed}
            toggled={toggled}
            handleToggleSidebar={handleToggleSidebar}
            handleCollapsedChange={handleCollapsedChange}
          />
        )}

        <main>
          <div className="btn-toggle" onClick={() => handleToggleSidebar(true)}>
            <FaBars />
          </div>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            {/* Profil User */}
            <Route
              path="/profilUser"
              element={
                <PROFILUSERRoute>
                  <ProfilUser />
                </PROFILUSERRoute>
              }
            />
            <Route
              path="/profilUser/:id/edit"
              element={
                <PROFILUSERRoute>
                  <UbahProfilUser />
                </PROFILUSERRoute>
              }
            />
            {/* Daftar User */}
            <Route
              path="/daftarUser"
              element={
                <DAFTARUSERRoute>
                  <DaftarUser />
                </DAFTARUSERRoute>
              }
            />
            <Route
              path="/daftarUser/:id"
              element={
                <DAFTARUSERRoute>
                  <DaftarUser />
                </DAFTARUSERRoute>
              }
            />
            <Route
              path="/daftarUser/:id/edit"
              element={
                <DAFTARUSERRoute>
                  <UbahUser />
                </DAFTARUSERRoute>
              }
            />
            <Route
              path="/daftarUser/tambahUser"
              element={
                <DAFTARUSERRoute>
                  <TambahUser />
                </DAFTARUSERRoute>
              }
            />
            {/* Setting */}
            <Route
              path="/setting"
              element={
                <SETTINGRoute>
                  <TampilSetting />
                </SETTINGRoute>
              }
            />
            <Route
              path="/setting/:id/edit"
              element={
                <SETTINGRoute>
                  <UbahSetting />
                </SETTINGRoute>
              }
            />
            {/* Customer */}
            <Route
              path="/customer"
              element={
                <CUSTOMERRoute>
                  <TampilCustomer />
                </CUSTOMERRoute>
              }
            />
            <Route
              path="/customer/:id"
              element={
                <CUSTOMERRoute>
                  <TampilCustomer />
                </CUSTOMERRoute>
              }
            />
            <Route
              path="/customer/:id/edit"
              element={
                <CUSTOMERRoute>
                  <UbahCustomer />
                </CUSTOMERRoute>
              }
            />
            <Route
              path="/customer/tambahCustomer"
              element={
                <CUSTOMERRoute>
                  <TambahCustomer />
                </CUSTOMERRoute>
              }
            />
            {/* Arsitek */}
            <Route
              path="/arsitek"
              element={
                <ARSITEKRoute>
                  <TampilArsitek />
                </ARSITEKRoute>
              }
            />
            <Route
              path="/arsitek/:id"
              element={
                <ARSITEKRoute>
                  <TampilArsitek />
                </ARSITEKRoute>
              }
            />
            <Route
              path="/arsitek/:id/edit"
              element={
                <ARSITEKRoute>
                  <UbahArsitek />
                </ARSITEKRoute>
              }
            />
            <Route
              path="/arsitek/tambahArsitek"
              element={
                <ARSITEKRoute>
                  <TambahArsitek />
                </ARSITEKRoute>
              }
            />
            {/* Cabang */}
            <Route
              path="/cabang"
              element={
                <CABANGRoute>
                  <TampilCabang />
                </CABANGRoute>
              }
            />
            <Route
              path="/cabang/:id"
              element={
                <CABANGRoute>
                  <TampilCabang />
                </CABANGRoute>
              }
            />
            <Route
              path="/cabang/:id/edit"
              element={
                <CABANGRoute>
                  <UbahCabang />
                </CABANGRoute>
              }
            />
            <Route
              path="/cabang/tambahCabang"
              element={
                <CABANGRoute>
                  <TambahCabang />
                </CABANGRoute>
              }
            />
            {/* Proyek */}
            <Route
              path="/daftarProyek"
              element={
                <PROYEKRoute>
                  <TampilDaftarProyek />
                </PROYEKRoute>
              }
            />
            <Route
              path="/daftarProyek/proyek/:id"
              element={
                <PROYEKRoute>
                  <TampilProyek />
                </PROYEKRoute>
              }
            />
            <Route
              path="/daftarProyek/proyek/:id/edit"
              element={
                <PROYEKRoute>
                  <UbahProyek />
                </PROYEKRoute>
              }
            />
            <Route
              path="/daftarProyek/proyek/tambahProyek"
              element={
                <PROYEKRoute>
                  <TambahProyek />
                </PROYEKRoute>
              }
            />
            {/* Laporan Proyek */}
            <Route
              path="/lapProyekSemua"
              element={
                <LAPPROYEKSEMUARoute>
                  <LapProyekSemua />
                </LAPPROYEKSEMUARoute>
              }
            />
            <Route
              path="/lapProyekMenunggu"
              element={
                <LAPPROYEKMENUNGGURoute>
                  <LapProyekMenunggu />
                </LAPPROYEKMENUNGGURoute>
              }
            />
            {/* RAB */}
            <Route
              path="/daftarRab"
              element={
                <RABRoute>
                  <TampilDaftarRab />
                </RABRoute>
              }
            />
            <Route
              path="/daftarRab/rab/:id"
              element={
                <RABRoute>
                  <TampilRab />
                </RABRoute>
              }
            />
            <Route
              path="/daftarRab/rab/:id/edit"
              element={
                <RABRoute>
                  <UbahRab />
                </RABRoute>
              }
            />
            <Route
              path="/daftarRab/rab/tambahRab"
              element={
                <RABRoute>
                  <TambahRab />
                </RABRoute>
              }
            />
            <Route
              path="/daftarRab/rab/:id/tambahRabPekerjaan"
              element={
                <RABRoute>
                  <TambahRabPekerjaan />
                </RABRoute>
              }
            />
            <Route
              path="/daftarRab/rab/:id/:idRabPekerjaan"
              element={
                <RABRoute>
                  <TampilRabPekerjaan />
                </RABRoute>
              }
            />
            <Route
              path="/daftarRab/rab/:id/:idRabPekerjaan/edit"
              element={
                <RABRoute>
                  <UbahRabPekerjaan />
                </RABRoute>
              }
            />
            <Route
              path="/daftarRab/rab/:id/:idRabPekerjaan/:idRabPekerjaanChild"
              element={
                <RABRoute>
                  <TampilRabPekerjaanChild />
                </RABRoute>
              }
            />
            <Route
              path="/daftarRab/rab/:id/:idRabPekerjaan/:idRabPekerjaanChild/edit"
              element={
                <RABRoute>
                  <UbahRabPekerjaanChild />
                </RABRoute>
              }
            />
            <Route
              path="/daftarRab/rab/:id/:idRabPekerjaan/tambahRabPekerjaanChild"
              element={
                <RABRoute>
                  <TambahRabPekerjaanChild />
                </RABRoute>
              }
            />
            {/* Kirim Gambar */}
            <Route
              path="/daftarKirimGambar"
              element={
                <KIRIMGAMBARRoute>
                  <TampilDaftarKirimGambar />
                </KIRIMGAMBARRoute>
              }
            />
            <Route
              path="/daftarKirimGambar/kirimGambar/:id"
              element={
                <KIRIMGAMBARRoute>
                  <TampilKirimGambar />
                </KIRIMGAMBARRoute>
              }
            />
            <Route
              path="/daftarKirimGambar/kirimGambar/:id/edit"
              element={
                <KIRIMGAMBARRoute>
                  <UbahKirimGambar />
                </KIRIMGAMBARRoute>
              }
            />
            <Route
              path="/daftarKirimGambar/kirimGambar/tambahKirimGambar"
              element={
                <KIRIMGAMBARRoute>
                  <TambahKirimGambar />
                </KIRIMGAMBARRoute>
              }
            />
            {/* Revisi */}
            <Route
              path="/daftarRevisi"
              element={
                <REVISIRoute>
                  <TampilDaftarRevisi />
                </REVISIRoute>
              }
            />
            <Route
              path="/daftarRevisi/revisi/:id"
              element={
                <REVISIRoute>
                  <TampilRevisi />
                </REVISIRoute>
              }
            />
            <Route
              path="/daftarRevisi/revisi/:id/edit"
              element={
                <REVISIRoute>
                  <UbahRevisi />
                </REVISIRoute>
              }
            />
            <Route
              path="/daftarRevisi/revisi/tambahRevisi"
              element={
                <REVISIRoute>
                  <TambahRevisi />
                </REVISIRoute>
              }
            />
            {/* PreOrder */}
            <Route
              path="/daftarPreOrder"
              element={
                <PREORDERRoute>
                  <TampilDaftarPreOrder />
                </PREORDERRoute>
              }
            />
            <Route
              path="/daftarPreOrder/preOrder/:id"
              element={
                <PREORDERRoute>
                  <TampilPreOrder />
                </PREORDERRoute>
              }
            />
            <Route
              path="/daftarPreOrder/preOrder/:id/edit"
              element={
                <PREORDERRoute>
                  <UbahPreOrder />
                </PREORDERRoute>
              }
            />
            <Route
              path="/daftarPreOrder/preOrder/tambahPreOrder"
              element={
                <PREORDERRoute>
                  <TambahPreOrder />
                </PREORDERRoute>
              }
            />
            {/* Produksi */}
            <Route
              path="/daftarProduksi"
              element={
                <PRODUKSIRoute>
                  <TampilDaftarProduksi />
                </PRODUKSIRoute>
              }
            />
            <Route
              path="/daftarProduksi/produksi/:id"
              element={
                <PRODUKSIRoute>
                  <TampilProduksi />
                </PRODUKSIRoute>
              }
            />
            <Route
              path="/daftarProduksi/produksi/:id/edit"
              element={
                <PRODUKSIRoute>
                  <UbahProduksi />
                </PRODUKSIRoute>
              }
            />
            <Route
              path="/daftarProduksi/produksi/tambahProduksi"
              element={
                <PRODUKSIRoute>
                  <TambahProduksi />
                </PRODUKSIRoute>
              }
            />
          </Routes>
          <Footer />
        </main>
      </div>
    </>
  );
};

export default App;
